import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Dashboard } from './pages/dashboard/dashboard';
import { Registration } from './pages/registration/registration';
import { Home } from './home/home';
import { Login } from './pages/login/login';
import { CourseDetails } from './pages/course-details/course-details';
import { CourseMain } from './pages/course-main/course-main';
import { VideoMain } from './pages/video-main/video-main';
import { CourseDetailsEvolvingTeaching } from './pages/course-details-evolving-teaching/course-details-evolving-teaching';
import { CourseMainEvolvingteaching } from './pages/course-main-evolvingteaching/course-main-evolvingteaching';
import { BookLiveSessionSlot } from './pages/book-live-session-slot/book-live-session-slot';
import { Feedback } from './feedback/feedback';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'dashboard', component: Dashboard },
  { path: 'register', component: Registration },
  {path: 'home', component: Home},
  {path:'login', component:Login},
  {path: 'main-course',component:CourseMain},
  {path:'Course-details', component:CourseDetails},
  {path:'Course-video', component:VideoMain},
  {path:'Course-Details-EvolvingTeaching',component:CourseDetailsEvolvingTeaching},
  {path:'Course-Main-Evolvingteaching',component:CourseMainEvolvingteaching},
  {path:'BookLive-Session',component:BookLiveSessionSlot},
  {path:'feedback',component:Feedback}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
